// @flow
import type {Action} from '../../../state/types'

export type SetGoogleMapPayload = {
  map: GoogleMap,
}

const id = 'map/SET_GOOGLE_MAP'

export const setGoogleMap = (map: GoogleMap): Action<SetGoogleMapPayload> => ({
  type: id,
  payload: {
    map,
  }
})

setGoogleMap.id = id
